/* Volt theme JS – vanilla, no dependencies */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const cfg = window.theme || {};

  /* Reveal on scroll (progressive: only hides content once JS is running) --- */
  try {
    document.documentElement.classList.add('js');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      $$('.reveal').forEach((el) => io.observe(el));
      /* Safety net: whatever happens, everything is visible after 2.5s */
      setTimeout(() => $$('.reveal:not(.is-visible)').forEach((el) => el.classList.add('is-visible')), 2500);
    } else {
      $$('.reveal').forEach((el) => el.classList.add('is-visible'));
    }
  } catch (e) {
    document.documentElement.classList.remove('js');
  }

  function formatMoney(cents) {
    const format = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (cents / 100).toFixed(2);
    let [int, dec] = value.split('.');
    let out;
    if (format.indexOf('amount_no_decimals') !== -1) {
      out = int;
    } else if (format.indexOf('amount_with_comma_separator') !== -1) {
      out = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
    } else {
      out = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + dec;
    }
    return format.replace(/\{\{\s*[a-z_]+\s*\}\}/, out);
  }

  /* Header: scroll shadow, search toggle, drawer ------------------------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  $$('[data-search-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = $('[data-search-panel]');
      if (!panel) return;
      const open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      if (open) { const input = $('input[type="search"]', panel); input && input.focus(); }
    });
  });
  const drawer = $('[data-drawer]');
  if (drawer) {
    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', !open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    $$('[data-drawer-open]').forEach((b) => b.addEventListener('click', () => setOpen(true)));
    $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  }


  /* Toast ----------------------------------------------------------------- */
  let toastTimer;
  function showToast(title, text) {
    let toast = $('[data-toast]');
    if (!toast) return;
    $('[data-toast-title]', toast).textContent = title;
    $('[data-toast-text]', toast).textContent = text || '';
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 6000);
  }
  $$('[data-toast-close]').forEach((b) => b.addEventListener('click', () => $('[data-toast]').classList.remove('is-visible')));

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
  }

  /* Quantity inputs ------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('.qty');
    const input = $('input', wrap);
    const min = parseInt(input.min || '1', 10);
    let val = parseInt(input.value || '1', 10) + parseInt(btn.dataset.qtyChange, 10);
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product form: variants, gallery, add to cart -------------------------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form ? $('input[name="id"]', form) : null;
    const selects = $$('[data-option-select]', root);
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare-price]', root);
    const skuEl = $('[data-sku]', root);
    const atc = $('[data-add-to-cart]', root);
    const atcText = atc ? $('[data-atc-text]', atc) : null;
    const stickyPrice = $('[data-sticky-price]');
    const mainImg = $('[data-gallery-main] img', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const stickyBtnEl = $('[data-sticky-submit]');
    function syncSticky(enabled, label) {
      if (!stickyBtnEl) return;
      stickyBtnEl.disabled = !enabled;
      if (label) stickyBtnEl.textContent = label;
    }

    function currentVariant() {
      if (!selects.length) return product.variants[0];
      const chosen = selects.map((s) => s.value);
      return product.variants.find((v) => chosen.every((val, i) => v.options[i] === val)) || null;
    }

    function setMedia(mediaId) {
      if (!mediaId || !mainImg) return;
      const thumb = thumbs.find((t) => t.dataset.mediaId === String(mediaId));
      if (thumb) thumb.click();
    }

    function render(variant, pushUrl) {
      if (!variant) {
        if (atc) { atc.disabled = true; atcText && (atcText.textContent = cfg.strings.unavailable); }
        syncSticky(false, cfg.strings.unavailable);
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.hidden = false;
          priceEl && priceEl.classList.add('price--sale');
        } else { compareEl.hidden = true; priceEl && priceEl.classList.remove('price--sale'); }
      }
      if (skuEl) { skuEl.textContent = variant.sku ? 'SKU: ' + variant.sku : ''; }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (atc) {
        atc.disabled = !variant.available;
        atcText && (atcText.textContent = variant.available ? cfg.strings.addToCart : cfg.strings.soldOut);
      }
      syncSticky(variant.available, variant.available ? cfg.strings.addToCart : cfg.strings.soldOut);
      if (variant.featured_media && variant.featured_media.id) setMedia(variant.featured_media.id);
      if (pushUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach((s) => s.addEventListener('change', () => render(currentVariant(), true)));
    render(currentVariant(), false);

    thumbs.forEach((t) => t.addEventListener('click', () => {
      const src = t.dataset.src;
      if (mainImg && src) {
        mainImg.src = src;
        mainImg.srcset = t.dataset.srcset || '';
        mainImg.alt = t.dataset.alt || mainImg.alt;
      }
      thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
    }));

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const chosen = currentVariant();
        if (!chosen || !chosen.available) { if (atc) atc.disabled = true; return; }
        if (atc) { atc.disabled = true; atc.classList.add('is-loading'); }
        const fd = new FormData(form);
        fetch(cfg.routes.cartAdd, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) { showToast(cfg.strings.error, data.description || data.message); return; }
            return fetch(cfg.routes.cart + '.js').then((r) => r.json()).then((cart) => {
              updateCartCount(cart.item_count);
              showToast(cfg.strings.addedTitle, (data.product_title || '') + (data.variant_title && data.variant_title !== 'Default Title' ? ' – ' + data.variant_title : ''));
            });
          })
          .catch(() => showToast(cfg.strings.error, ''))
          .finally(() => { if (atc) { const v = currentVariant(); atc.disabled = !(v && v.available); atc.classList.remove('is-loading'); } });
      });
    }

    // Sticky add-to-cart on mobile
    const sticky = $('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      });
      io.observe(atc);
      const stickyBtn = $('[data-sticky-submit]', sticky);
      stickyBtn && stickyBtn.addEventListener('click', () => { const v = currentVariant(); if (form && v && v.available) form.requestSubmit(); });
    }
  });

  /* Tabs ------------------------------------------------------------------ */
  $$('[data-tabs]').forEach((tabs) => {
    const btns = $$('[data-tab]', tabs);
    const panels = $$('[data-tab-panel]', tabs);
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-selected', x === b); });
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.tabPanel === b.dataset.tab));
    }));
  });
  $$('[data-tab-jump]').forEach((j) => j.addEventListener('click', () => {
    const target = $('[data-tab="' + j.dataset.tabJump + '"]');
    if (!target) return;
    target.click();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  /* Cart page ------------------------------------------------------------- */
  const cartRoot = $('[data-cart]');
  if (cartRoot) {
    function changeLine(line, quantity) {
      cartRoot.classList.add('is-loading');
      fetch(cfg.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, quantity }) })
        .then((r) => r.json())
        .then(() => window.location.reload())
        .catch(() => window.location.reload());
    }
    cartRoot.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-qty]');
      if (input) changeLine(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10));
    });
    cartRoot.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.lineRemove, 10), 0); }
    });
    const note = $('[data-cart-note]', cartRoot);
    if (note) {
      let t;
      note.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(() => fetch(cfg.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }), 500);
      });
    }
  }

  /* Product recommendations ---------------------------------------------- */
  $$('[data-recommendations]').forEach((el) => {
    const url = el.dataset.url;
    if (!url) return;
    fetch(url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; el.hidden = false; }
    }).catch(() => {});
  });

  /* Facets: submit on change ---------------------------------------------- */
  const facetForm = $('[data-facets-form]');
  if (facetForm) {
    facetForm.addEventListener('change', (e) => { if (e.target.type !== 'number') facetForm.requestSubmit(); });
    $$('[data-facets-toggle]').forEach((b) => b.addEventListener('click', () => { const f = $('[data-facets]'); f && f.classList.toggle('is-open'); }));
  }
  const sortSelect = $('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Address forms (customer) --------------------------------------------- */
  $$('[data-address-toggle]').forEach((b) => b.addEventListener('click', () => {
    const target = document.getElementById(b.getAttribute('aria-controls'));
    if (target) { const open = target.classList.toggle('is-open'); b.setAttribute('aria-expanded', open); }
  }));
  $$('[data-address-delete]').forEach((b) => b.addEventListener('click', (e) => {
    if (!window.confirm(cfg.strings.confirmDelete)) { e.preventDefault(); return; }
    const f = document.createElement('form'); f.method = 'post'; f.action = b.dataset.target;
    f.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f); f.submit();
  }));
  if (window.Shopify && window.Shopify.CountryProvinceSelector) {
    $$('[data-address-country]').forEach((sel) => {
      const id = sel.id; const province = sel.dataset.province;
      new window.Shopify.CountryProvinceSelector(id, province, { hideElement: province + '-container' });
    });
  }
})();
